import React, { useCallback, useRef } from 'react';
import classnames from 'classnames';
import { useBoolean } from '@entegral/helpers.react/hooks/boolean';
import { useDropdownClassName } from '@entegral/helpers.react/hooks/dropdown-classname';
import { useWindowEventWithFlag } from '@entegral/helpers.react/hooks/window-event-with-flag';
import { stopPropagation } from '@entegral/helpers.react/events/stop-propagation';

export function Dropdown({
  id,
  name,
  options,
  selectedOption,
  onSelect,
  placeholder,
  baseClassName=`dropdown`,
  extraClassName,

  prefix,
  postfix,

  outsideConstraintTarget,
  optionsComponent,
}) {
  let target = useRef();
  let [isOpen, open, close] = useBoolean(false);
  let className = useDropdownClassName(baseClassName, extraClassName, isOpen);
  let selected = selectedOption || { value: placeholder };

  useWindowEventWithFlag('click', close, isOpen);

  let select = useCallback(option => {
    onSelect(option, name);
    close();
  }, [onSelect, name]);

  let OptionsComponent = optionsComponent || Options;

  return (
    <div
      id={id}
      className={className}
      onClick={isOpen ? close : open}
      ref={target}
    >
      <Value
        value={selected}
        baseClassName={baseClassName}
        haveValue={!!selectedOption}
        prefix={prefix}
        postfix={postfix}
      />

      {isOpen && (
        <OptionsComponent
          options={options}
          selectedOption={selectedOption}
          select={select}
          baseClassName={baseClassName}

          target={target}
          outsideConstraintTarget={outsideConstraintTarget}
        />
      )}
    </div>
  );
}

export function Options({
  options,
  selectedOption,
  select,
  baseClassName,
  extraClassName,
}) {
  return (
    <div
      className={classnames(`${baseClassName}__options`, extraClassName)}
      onClick={stopPropagation}
    >
      {
        options.map(x => (
          <Option
            key={x.value}
            option={x}
            isSelected={selectedOption && x.value === selectedOption.value}
            select={select}
            baseClassName={baseClassName}
          />
        ))
      }
    </div>
  );
}

function Option({
  option,
  isSelected,
  select,
  baseClassName,
}) {
  let selectOption = useCallback(() => !option.disabled && select(option), [option, select]);

  let text = option.name || option.value;

  return (
    <div
      className={classnames(
        `${baseClassName}__option`,
        `${baseClassName}__option_type_single`,
        {
          [`${baseClassName}__option_state_selected`]: isSelected,
          [`${baseClassName}__option_state_disabled`]: option.disabled,
        }
      )}
      onClick={selectOption}
    >
      {text}
    </div>
  );
}

function Value({
  value,
  haveValue,
  baseClassName,
  prefix,
  postfix,
}) {
  let text = value.name || value.value || ``;

  return (
    <div className={`${baseClassName}__value`}>
      <div className={`${baseClassName}__value-text`}>
        {haveValue && prefix}{text}{haveValue && postfix}
      </div>
    </div>
  );
}
